  <template>
  <v-card class="result_card">
    <v-card-title primary-title>
      <v-layout row wrap>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs12 md9>
              <div class="result_title_star subheading primary--text" >
                <result-checkbox :result="result"></result-checkbox>
                  <a href="#" onClick="return false;"
                    slot="activator"
                    v-if="displayShowDocument"
                    @click="showDocument(result); onClickOpen('click-showmore', result.reportId, result.label)"
                  ><ais-highlight :result="result" attribute-name="label"></ais-highlight></a>
              </div>
              <div class='caption'>
                <span v-if="result.targetRetailer">Retailer: </span><b><i><span class="snippet" v-text="result.targetRetailer"/></i></b>
                <span v-if="result.targetSupplier">Supplier: </span><b><i><span class="snippet" v-text="result.targetSupplier"/></i></b>
                <span v-if="!(result.targetRetailer || result.targetSupplier)">Company: <b><i><span class="snippet" v-text="result.source"/></i></b></span>
                <span> - Document type: </span><i><span class="snippet" v-text="result.type"/></i></div>
            </v-flex>
            <v-flex xs12 md3 v-if="$vuetify.breakpoint.mdAndDown ? false: true" style="margin-bottom:8px">
              <v-img class="source_img" contain position="center right" :src="result.sourceLogo && `${attachment_path}${result.sourceLogo}`" />
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- second line.
          show list of page in full page if there are no region nor brand
        -->
        <v-flex xs12 >
          <v-layout row wrap>

            <v-flex :class="($vuetify.breakpoint.lgAndUp && user && user.access_right[algolia_company_reports_index_name]['show_tag'] && (region || retailerAndBrand || supplierAndBrand || category)) ? 'xs8': 'xs12'" >
              <div v-for="resultByReport in resultsByReportId"
                :key="resultByReport.name">
                <v-layout row wrap>
                  <v-flex md12 lg12 >
                    <div class="result_page" >
                      <v-btn flat icon slot="activator" class="left_icon_tag primary--text" v-if="displayShowDocument"
                         @click.native="showDocument(resultByReport); onClickOpen('click-open-page', result.reportId, result.label, resultByReport.pageNumber)"
                         style="margin:0px!important;" >
                          <v-icon dark class="btn_icone">open_in_new</v-icon>
                      </v-btn>
                      <div><b><i>Page <span v-text="resultByReport.pageNumber"/> - </i></b>
                        <span class="snippet" v-html="
                          resultByReport._snippetResult !== undefined && resultByReport._snippetResult.text && `${resultByReport._snippetResult['text']['value']}...`"/>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex :class="($vuetify.breakpoint.lgAndUp && (region || retailerAndBrand || supplierAndBrand || category)) ? 'xs4': 'xs12'"
                    :style="($vuetify.breakpoint.lgAndUp && (region || retailerAndBrand || supplierAndBrand || category)) ? 'padding-left:15px;': 'visible:hidden;'"
                    v-if="user && user.access_right[algolia_company_reports_index_name]['show_tag']" >
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row v-show="region" >
                    <v-flex xs1 class="flag_icon">
                      <v-tooltip top>
                        <v-icon color="orange" slot="activator">map</v-icon>
                        <span>Region / Country / City / Airport</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                      <span v-text="region"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-show="retailerAndBrand" >
                    <v-flex xs1 class="flag_icon">
                      <v-tooltip top>
                        <v-icon color="blue" slot="activator">shopping_cart</v-icon>
                        <span>Retailer | Related actors</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                      <span v-text="retailerAndBrand"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-show="supplierAndBrand" >
                    <v-flex xs1 class="flag_icon">
                      <v-tooltip top>
                        <v-icon color="light-green" slot="activator">work</v-icon>
                        <span>Supplier | Brand</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                      <span v-text="supplierAndBrand"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-show="category" >
                    <v-flex xs1 class="flag_icon">
                      <v-tooltip top>
                        <v-icon class="red--text" slot="activator">list</v-icon>
                        <span>Category</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                      <span v-text="category"/>
                    </v-flex>
                  </v-layout>
                  <br />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-title>
  </v-card>
</template>

<script>
import resultPanelConstructor from '../ResultPanelConstructor'
import { mapMutations } from 'vuex'
import USER from '@/graphql/User.gql'
import LOGGER from '@/graphql/Logger.gql'

export default {
  name: 'CompanyReportResultPanel',
  extends: resultPanelConstructor,
  data () {
    return {
      user: false,
      attachment_path: process.env.VUE_APP_ATTACHMENT_PATH,
      algolia_company_reports_index_name: process.env.VUE_APP_ALGOLIA_COMPANY_REPORTS_INDEX_NAME
    }
  },
  computed: {
    region () {
      let res = ''
      if (this.result.region !== undefined && this.result.region.length > 0) {
        res += this.result.region.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.country !== undefined && this.result.country.length > 0) { res += ' - ' }
      if (this.result.country !== undefined && this.result.country.length > 0) {
        res += this.result.country.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.city !== undefined && this.result.city.length > 0) { res += ' - ' }
      if (this.result.city !== undefined && this.result.city.length > 0) {
        res += this.result.city.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.airport !== undefined && this.result.airport.length > 0) { res += ' - ' }
      if (this.result.airport !== undefined && this.result.airport.length > 0) {
        res += this.result.airport.map(v => v.n).join(', ')
      }
      return res
    },
    retailerAndBrand () {
      let res = ''
      if (this.result.retailer !== undefined && this.result.retailer.length > 0) {
        res += this.result.retailer.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.retailerBrand !== undefined && this.result.retailerBrand.length > 0) { res += ' - ' }
      if (this.result.retailerBrand !== undefined && this.result.retailerBrand.length > 0) {
        res += this.result.retailerBrand.map(v => v.n).join(', ')
      }
      return res
    },
    supplierAndBrand () {
      let res = ''
      if (this.result.company !== undefined && this.result.company.length > 0) {
        res += this.result.company.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.brand !== undefined && this.result.brand.length > 0) { res += ' - ' }
      if (this.result.brand !== undefined && this.result.brand.length > 0) {
        res += this.result.brand.map(v => v.n).join(', ')
      }
      return res
    },
    category () {
      let res = ''
      if (this.result.category !== undefined && this.result.category.length > 0) {
        res += this.result.category.map(v => v.n).join(', ')
      }
      return res
    }
  },
  methods: {
    ...mapMutations('documentForm', ['setViewedDocument', 'setViewedDocumentDialog']),
    async showDocument (result) {
      await this.setViewedDocument(result)
      this.setViewedDocumentDialog(true)
    },
    onClickOpen (action, reportId, title, page = '1') {
      this.$apollo.mutate({
        mutation: LOGGER,
        variables: {
          level: 'info',
          message: JSON.stringify({
            module: this.$route.name,
            action,
            reportId,
            title,
            page
          })
        }
      })
    }
  },
  apollo: {
    user: {
      query: USER,
      skip () {
        return !this.$auth0.isAuthenticated()
      }
    }
  }
}
</script>
<style>
.result_card {
  padding-bottom: 5px;
}
.result_page {
    display: table;
    min-height:35px;
}
.result_page div {
    vertical-align: middle;
    display: table-cell;
    text-align: left;
}

.left_icon_tag {
  float: left;
}
.left_icon_tag .v-input__control {
  height: 28px;
}
.left_icon_tag{
  margin-top: 2px;
  padding-top: 0px;
}
</style>
